import {
    documentApi,
    brandApi,
    regionApi,
    areasApi,
    countryApi,
    propertyApi,
    contentApi,
    previewApi,
    variantApi,
    variantHistoryApi,
    downloadDocumentApi,
    authApi,
    appSettingsApi,
    documentSettingsApi,
    workspacesApi,
    systemSettingsApi,
    documentsAdminApi,
    chaptersAdminApi,
    sectionsAdminApi,
    sectionsMandatoryConditionsAdminApi,
    variantsAdminApi,
    tagsAdminApi,
    vendorsAdminApi,
    productsAdminApi,
    usersAdminApi,
    reorderAdminApi,
    publishAdminApi,
    unpublishedAdminApi,
    previewAdminApi,
    downloadDocumentPreviewAdminApi,
    searchAdminApi,
    logsAdminApi,
    appSettingsAdminApi,
    documentSettingsAdminApi,
    workspacesAdminApi,
    systemSettingsAdminApi,
    attachmentsAdminApi,
    brandsAdminApi,
    regionsAdminApi,
    regionsReadApi,
    countriesAdminApi,
    countriesReadApi,
    areasAdminApi,
    areasReadApi,
    serviceLevelsAdminApi,
    serviceLevelsReadApi,
    propertiesAdminApi,
    propertiesReadApi,
} from '@SERVICES';

import stepsPersistMiddleware from '@MIDDLEWARES/stepsPersistMiddleware';

export default [
    stepsPersistMiddleware,

    documentApi.middleware,
    brandApi.middleware,
    regionApi.middleware,
    areasApi.middleware,
    countryApi.middleware,
    propertyApi.middleware,
    contentApi.middleware,
    previewApi.middleware,
    variantApi.middleware,
    variantHistoryApi.middleware,
    downloadDocumentApi.middleware,
    authApi.middleware,
    appSettingsApi.middleware,
    documentSettingsApi.middleware,
    workspacesApi.middleware,
    systemSettingsApi.middleware,

    // ADMIN
    documentsAdminApi.middleware,
    chaptersAdminApi.middleware,
    sectionsAdminApi.middleware,
    sectionsMandatoryConditionsAdminApi.middleware,
    variantsAdminApi.middleware,
    tagsAdminApi.middleware,
    vendorsAdminApi.middleware,
    productsAdminApi.middleware,
    usersAdminApi.middleware,
    reorderAdminApi.middleware,
    publishAdminApi.middleware,
    unpublishedAdminApi.middleware,
    previewAdminApi.middleware,
    downloadDocumentPreviewAdminApi.middleware,
    searchAdminApi.middleware,
    logsAdminApi.middleware,
    appSettingsAdminApi.middleware,
    documentSettingsAdminApi.middleware,
    workspacesAdminApi.middleware,
    systemSettingsAdminApi.middleware,
    attachmentsAdminApi.middleware,
    brandsAdminApi.middleware,
    regionsAdminApi.middleware,
    regionsReadApi.middleware,
    countriesAdminApi.middleware,
    countriesReadApi.middleware,
    areasAdminApi.middleware,
    areasReadApi.middleware,
    serviceLevelsAdminApi.middleware,
    serviceLevelsReadApi.middleware,
    propertiesAdminApi.middleware,
    propertiesReadApi.middleware,
];
